export function createOptions(data, textPropertyName = 'name', textPropertyName2?) {
  return data.map((item) => ({
    id: item.id !== undefined && item.id !== null ? item.id : '',
    text: item[textPropertyName] + (textPropertyName2 ? ' ' + item[textPropertyName2] : ''),
    val: item.id !== undefined && item.id !== null ? item.id : '',
  }));
}
